// Split a stored checkbox value (options joined with ", ") back into its selected options, matching against the question's own option list
// so a label that itself contains a comma (e.g. "Dry, Oily") isn't mistaken for two separate selections.
export function parseCheckboxOptions(raw, options = []) {
  const remaining0 = String(raw ?? "").trim();
  if (!remaining0) return [];

  const known = [...new Set((options || []).map(o => String(o).trim()).filter(Boolean))].sort(
    (a, b) => b.length - a.length
  );

  if (!known.length) {
    // Legacy values stored before options were tracked: plain comma-split is the only option.
    return remaining0.split(",").map(s => s.trim()).filter(Boolean);
  }

  let remaining = remaining0;
  const selected = [];

  while (remaining.length) {
    const match = known.find(
      opt => remaining.startsWith(opt) && (remaining.length === opt.length || remaining[opt.length] === ",")
    );
    if (!match) {
      // No known option matches here — take just the next comma-delimited segment as one unrecognized (stale/renamed) value,
      // then keep matching known options in whatever follows, instead of giving up on the rest of the string entirely.
      const commaIdx = remaining.indexOf(",");
      if (commaIdx === -1) {
        selected.push(remaining.trim());
        break;
      }
      selected.push(remaining.slice(0, commaIdx).trim());
      remaining = remaining.slice(commaIdx + 1).replace(/^\s+/, "");
      continue;
    }
    selected.push(match);
    remaining = remaining.slice(match.length).replace(/^\s+/, "");
    if (remaining.startsWith(",")) {
      remaining = remaining.slice(1).replace(/^\s+/, "");
    }
  }
  return selected;
}
